import { Injectable } from '@angular/core';
import { GlobalTrackingService } from './global-tracking.service';
import { StorageService } from './storage.service';
import { AuthService } from '@spartacus/core';
import { PURCHASE_TERMS_CONDITION_DATA } from '../models/purchase-terms-condition-tracking.model';
import { ActionType, Country, LoginStatus, pageData, PageReadyData, userData } from '../models/global-tracking.model';
import { Router } from '@angular/router';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PurchaseTermsConditionTrackingService {

  constructor(
    private globalTrackingService: GlobalTrackingService,
    private storageService: StorageService,
    private authService: AuthService,
    private router: Router
  ) { }

  pageLoadTrackingData(): void {
    let loginStatus: string;
    this.authService.isUserLoggedIn().pipe(take(1)).subscribe((data) => loginStatus = data ? LoginStatus.LOGGED_IN : LoginStatus.LOGGED_OUT);

    const pageData: pageData = {
      path: this.router.url,
      title: PURCHASE_TERMS_CONDITION_DATA.TITLE,
      country: Country.COUNTRY,
      language: this.storageService.selectedLanguage || '',
      template: PURCHASE_TERMS_CONDITION_DATA.TEMPLATE,
    };

    const user: userData = {
      loginStatus: loginStatus,
      role: this.storageService?.userRoles || '',
      company: this.storageService?.defaultLegalEntity?.name || '',
      companyId:
        this.storageService?.defaultLegalEntity?.uid || '',
    };

    const pageLoadData: PageReadyData = {
      page: pageData,
      user: user,
    };

    this.globalTrackingService.sendPageReadyData(ActionType.PAGE_READY, pageLoadData);
  }
}
